module.exports = __webpack_public_path__ + "static/media/badge.225a88d4.svg";